<template>
    <loading v-if="loading" :size="2" :message="false"></loading>
    <div v-else>
        <button
                v-if="order.canOrderUpdate && !order.canceled"
                class="btn btn-sm btn-primary"
                v-b-modal.ModalEditOrder
                @click.stop="initEditOrder"
                v-b-tooltip title="Изменить заказ">
            <i class="fa fa-pencil"></i>
        </button>
        <button
                v-if="order.canOrderDelete"
                class="btn btn-sm btn-danger"
                @click.stop="removeOrder()"
                v-b-tooltip
                title="Удалить заказ">
            <i class="fa fa-trash"></i>
        </button>
    </div>
</template>
<script>
  import { mapActions } from 'vuex'
  import { ADD_TOAST_MESSAGE } from 'vuex-toast'

  export default {
    props: ['order'],
    data () {
      return {
        loading: false
      }
    },
    methods: {
      initEditOrder () {
        this.$store.commit('SET_EDIT_ORDER', this.order)
      },
      removeOrder () {
        this.loading = true
        this.$store.dispatch('deleteOrder', this.order.id).then(() => {
          this.loading = false
          this.addToast({
            text: 'Заказ удален',
            type: 'success',
            dismissAfter: 3000
          })
        }).catch((error) => {
          this.loading = false
          this.addToast({
            text: 'Произошла ошибка при удалении заказа: ' + error,
            type: 'danger',
            dismissAfter: 3000
          })
        })
      },
      ...mapActions({
        addToast: ADD_TOAST_MESSAGE
      })
    }
  }
</script>




// WEBPACK FOOTER //
// OrderActions.vue?1435347a